// extracted by mini-css-extract-plugin
module.exports = {"section":"B14F4vqTLawCdKQKeFUE7"};